import { Translation } from 'hooks/useTranslation/useTranslation';
import { PageTabItems } from 'v2/components/PageTabs/PageTabs';

export const createUsersTabs = (translation: Translation): PageTabItems => [
  {
    text: translation.all_users,
    path: '/users/overview'
  },
  {
    text: translation.user_groups,
    path: '/users/groups/overview'
  }
];
